import { AppSettingsModule } from 'services/settings.provider';
import { DataServiceModule } from 'services/data/data.service';

export const DiscountsRESTServiceModule = angular
    .module('app.services.data.discountsRESTService', [
        DataServiceModule,
        AppSettingsModule
    ]).service('discountsRESTService', (
        dataService,
        settings,
    ) => {
        return {
            create,
            searchDiscounts,
            updateDiscount
        };

        function searchDiscounts(filter) {
            const filterString = filter ? `?filter=discountCode+cont+${filter}+and+discountStatus+eq+active` : '';
            return dataService.get(`${settings.api.discountsREST}${filterString}`).then(({ discounts = [] }) => {
                return discounts
                    .filter(discount => discount.discountCode && discount.name !== 'Custom')
                    .map(transformDiscount);
            });
        }

        function create(discount) {
            return dataService.create(settings.api.discountsREST, discount).then((response) => {
                return transformDiscount(response);
            });
        }

        function transformDiscount(restDiscount) {
            return {
                code: restDiscount.discountCode,
                discount: restDiscount
            };
        }

        function updateDiscount(discount, updatedDiscountAmount) {
            if (!discount
                || !discount.discountId
                || !discount.targets
                || updatedDiscountAmount === undefined
                || updatedDiscountAmount === null
            ) {
                return;
            }
            let patches = [];
            const discountTargetId = Object.keys(discount.targets)[0];
            const updateDiscountAmountPatch = {
                op: 'replace',
                path: `/targets/${discountTargetId}/discountAmount`,
                value: updatedDiscountAmount
            };
            patches.push(updateDiscountAmountPatch);
            return dataService.patch(settings.api.discountsREST, discount.discountId, patches)
                .then(() => {
                    discount.targets[discountTargetId].discountAmount = updatedDiscountAmount;
                    return transformDiscount(discount);
                });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/discountsREST.service.js